import React, { useState } from 'react';
import { translateLanguage } from '../utils/UtilityFunctions';
import './Search.scss';

interface SearchFilterProps {
  onSelectedFilter(arg: string): any;
  selectedFilter: string;
  language: string;
}

export default function SearchFilterDesktop({
  onSelectedFilter,
  selectedFilter,
  language,
}: SearchFilterProps) {
  const [selected, setSelected] = useState<string>(selectedFilter);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
    onSelectedFilter(e.target.value);
  };

  return (
    <div className="search-filter">
      <div className="search-filter__header">
        {translateLanguage(language, 'Filter by:', 'Filtrado por:')}
      </div>
      <div className="search-filter__button-container">
        <ul>
          <li>
            <input
              id="allDesktop"
              type="radio"
              value="All"
              name="filterDesktop"
              checked={selected === 'All'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-all-desktop"
            />
            <label htmlFor="allDesktop">
              {translateLanguage(language, 'Show all', 'Mostrar todos los resultados')}
            </label>
          </li>
          <li>
            <input
              id="agenciesDesktop"
              type="radio"
              value="Drupal_TaxonomyTermAgencies"
              name="filterDesktop"
              checked={selected === 'Drupal_TaxonomyTermAgencies'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-agencies-desktop"
            />
            <label htmlFor="agenciesDesktop">
              {translateLanguage(language, 'Agencies', 'Agencias')}
            </label>
          </li>
          <li>
            <input
              id="servicesDesktop"
              type="radio"
              value="Drupal_TaxonomyTermServices"
              name="filterDesktop"
              checked={selected === 'Drupal_TaxonomyTermServices'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-services-desktop"
            />
            <label htmlFor="servicesDesktop">
              {translateLanguage(language, 'Services', 'Servicios')}
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
}

export function SearchFilterMobile({
  onSelectedFilter,
  selectedFilter,
  language,
}: SearchFilterProps) {
  const [selected, setSelected] = useState<string>(selectedFilter);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
    onSelectedFilter(e.target.value);
  };

  return (
    <div className="search-filter">
      <div className="search-filter__header">
        {translateLanguage(language, 'Filter by:', 'Filtrado por:')}
      </div>
      <div className="search-filter__button-container">
        <ul>
          <li>
            <input
              id="all"
              type="radio"
              value="All"
              name="filter"
              checked={selected === 'All'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-all-mobile"
            />
            <label htmlFor="all">
              {translateLanguage(language, 'Show all', 'Mostrar todos los resultados')}
            </label>
          </li>
          <li>
            <input
              id="agencies"
              type="radio"
              value="Drupal_TaxonomyTermAgencies"
              name="filter"
              checked={selected === 'Drupal_TaxonomyTermAgencies'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-agencies-mobile"
            />
            <label htmlFor="agencies">{translateLanguage(language, 'Agencies', 'Agencias')}</label>
          </li>
          <li>
            <input
              id="services"
              type="radio"
              value="Drupal_TaxonomyTermServices"
              name="filter"
              checked={selected === 'Drupal_TaxonomyTermServices'}
              onChange={(e) => handleOnChange(e)}
              data-testid="search-filter-services-mobile"
            />
            <label htmlFor="services">{translateLanguage(language, 'Services', 'Servicios')}</label>
          </li>
        </ul>
      </div>
    </div>
  );
}
